module.exports = __webpack_public_path__ + "static/img/boutique-top.20259b5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/boutique-top.jpg
// module id = 1377
// module chunks = 1